module.exports = __webpack_public_path__ + "static/media/espace-repas-ext.66ff367f.svg";